var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergydark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 933,
    viewBox: "0 0 1000 933",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_885_10306",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1000,
    height: 933
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000 0H0V932.25H1000V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_885_10306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 0H0V932.25H1000V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 901.19C363.49 921.59 363.49 934.84 363.49 934.91C363.43 947.5 356.68 960.03 343.82 970.82C339.98 974.05 335.56 977.14 330.6 979.98C327.43 981.82 324.12 983.5 320.7 985.08C313.45 988.39 305.68 991.1 297.56 993.2C290.08 995.18 282.32 996.63 274.4 997.58C266.79 998.5 259.01 998.98 251.26 998.98C243.51 999.01 235.74 998.53 228.1 997.62C220.2 996.67 212.44 995.22 204.96 993.25C196.85 991.16 189.07 988.46 181.82 985.16C178.32 983.59 174.93 981.85 171.71 979.98C166.84 977.16 162.52 974.16 158.71 970.99C145.44 959.94 138.79 947.03 138.79 934.13V900.41C138.79 913.32 145.43 926.22 158.71 937.26C162.52 940.43 166.84 943.44 171.71 946.25C174.94 948.13 178.33 949.86 181.82 951.46C189.07 954.75 196.85 957.44 204.96 959.54C212.44 961.51 220.2 962.94 228.1 963.89C235.73 964.8 243.5 965.27 251.26 965.26C259.01 965.26 266.8 964.79 274.4 963.85C282.32 962.9 290.07 961.46 297.56 959.48C305.68 957.38 313.45 954.67 320.7 951.36C324.12 949.77 327.42 948.09 330.6 946.25C335.56 943.4 339.98 940.31 343.82 937.09C356.69 926.33 363.23 913.77 363.49 901.19Z",
    fill: "#969A9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 870.07V901.18C363.23 913.76 356.68 926.31 343.82 937.08C339.98 940.31 335.56 943.4 330.6 946.24C327.43 948.08 324.12 949.76 320.7 951.35C313.45 954.66 305.68 957.37 297.56 959.47C290.08 961.45 282.32 962.89 274.4 963.84C266.79 964.78 259.01 965.25 251.26 965.25C243.51 965.26 235.74 964.79 228.1 963.88C220.2 962.93 212.44 961.49 204.96 959.53C196.85 957.43 189.07 954.74 181.82 951.45C178.32 949.85 174.93 948.13 171.71 946.24C166.84 943.43 162.52 940.42 158.71 937.25C145.44 926.21 138.79 913.31 138.79 900.4V869.3C138.79 882.19 145.43 895.1 158.71 906.15C162.52 909.32 166.84 912.33 171.71 915.14C174.94 917.02 178.33 918.75 181.82 920.35C189.07 923.63 196.85 926.33 204.96 928.43C212.44 930.38 220.2 931.83 228.1 932.78C235.73 933.69 243.5 934.16 251.26 934.15C259.01 934.15 266.8 933.66 274.4 932.74C282.32 931.79 290.07 930.34 297.56 928.36C305.68 926.26 313.45 923.55 320.7 920.25C324.12 918.66 327.42 916.98 330.6 915.14C335.56 912.29 339.98 909.2 343.82 905.98C356.69 895.22 363.23 882.66 363.49 870.07Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 838.98V870.08C363.23 882.67 356.68 895.23 343.82 905.99C339.98 909.22 335.56 912.31 330.6 915.15C327.43 916.99 324.12 918.67 320.7 920.26C313.45 923.55 305.68 926.27 297.56 928.37C290.08 930.35 282.32 931.8 274.4 932.75C266.79 933.67 259.01 934.16 251.26 934.16C243.51 934.17 235.74 933.7 228.1 932.79C220.2 931.84 212.44 930.39 204.96 928.44C196.85 926.34 189.07 923.64 181.82 920.36C178.32 918.76 174.93 917.04 171.71 915.15C166.84 912.34 162.52 909.33 158.71 906.16C145.44 895.11 138.79 882.2 138.79 869.31V838.2C138.79 851.11 145.43 864.01 158.71 875.06C162.52 878.22 166.84 881.23 171.71 884.05C174.94 885.92 178.33 887.64 181.82 889.24C189.07 892.53 196.85 895.22 204.96 897.32C212.44 899.29 220.2 900.72 228.1 901.67C235.73 902.59 243.5 903.07 251.26 903.04C259.01 903.04 266.8 902.57 274.4 901.63C282.32 900.68 290.07 899.24 297.56 897.26C305.68 895.16 313.45 892.45 320.7 889.14C324.12 887.55 327.42 885.87 330.6 884.04C335.56 881.18 339.98 878.1 343.82 874.88C356.69 864.1 363.23 851.56 363.49 838.97V838.98Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 807.88V838.98C363.23 851.57 356.68 864.11 343.82 874.89C339.98 878.12 335.56 881.19 330.6 884.05C327.43 885.88 324.12 887.56 320.7 889.15C313.45 892.46 305.68 895.17 297.56 897.27C290.08 899.25 282.32 900.69 274.4 901.64C266.79 902.58 259.01 903.05 251.26 903.05C243.51 903.08 235.74 902.6 228.1 901.68C220.2 900.73 212.44 899.29 204.96 897.33C196.85 895.23 189.07 892.54 181.82 889.25C178.32 887.65 174.93 885.93 171.71 884.06C166.84 881.24 162.52 878.23 158.71 875.07C145.44 864.02 138.79 851.11 138.79 838.21V807.11C138.79 820.02 145.43 832.92 158.71 843.96C162.52 847.13 166.84 850.14 171.71 852.95C174.94 854.83 178.33 856.56 181.82 858.16C189.07 861.44 196.85 864.14 204.96 866.24C212.44 868.19 220.2 869.64 228.1 870.59C235.73 871.5 243.5 871.97 251.26 871.96C259.01 871.96 266.8 871.49 274.4 870.55C282.32 869.6 290.07 868.15 297.56 866.17C305.68 864.08 313.45 861.37 320.7 858.06C324.12 856.47 327.42 854.79 330.6 852.95C335.56 850.1 339.98 847.01 343.82 843.79C356.69 833.03 363.23 820.47 363.49 807.89V807.88Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 776.76V807.87C363.23 820.45 356.68 833 343.82 843.77C339.98 847 335.56 850.09 330.6 852.93C327.43 854.77 324.12 856.45 320.7 858.04C313.45 861.35 305.68 864.06 297.56 866.15C290.08 868.13 282.32 869.58 274.4 870.53C266.79 871.47 259.01 871.94 251.26 871.94C243.51 871.95 235.74 871.48 228.1 870.57C220.2 869.62 212.44 868.17 204.96 866.22C196.85 864.12 189.07 861.42 181.82 858.14C178.32 856.54 174.93 854.82 171.71 852.93C166.84 850.12 162.52 847.11 158.71 843.94C145.44 832.9 138.79 820 138.79 807.09V775.98C138.79 788.89 145.43 801.79 158.71 812.84C162.52 816 166.84 819.04 171.71 821.84C174.94 823.7 178.33 825.42 181.82 827.03C189.07 830.31 196.85 833.01 204.96 835.12C212.44 837.06 220.2 838.5 228.1 839.46C235.73 840.37 243.5 840.84 251.26 840.82C259.01 840.82 266.8 840.35 274.4 839.42C282.32 838.47 290.07 837.02 297.56 835.04C305.68 832.94 313.45 830.23 320.7 826.92C324.12 825.36 327.42 823.67 330.6 821.84C335.56 818.97 339.98 815.89 343.82 812.66C356.69 801.9 363.23 789.34 363.49 776.75V776.76Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 745.66V776.76C363.23 789.35 356.68 801.91 343.82 812.67C339.98 815.9 335.56 818.97 330.6 821.85C327.43 823.68 324.12 825.37 320.7 826.93C313.45 830.24 305.68 832.95 297.56 835.05C290.08 837.03 282.32 838.48 274.4 839.43C266.79 840.35 259.01 840.83 251.26 840.83C243.51 840.86 235.74 840.38 228.1 839.47C220.2 838.51 212.44 837.07 204.96 835.13C196.85 833.02 189.07 830.32 181.82 827.04C178.32 825.43 174.93 823.7 171.71 821.85C166.84 819.04 162.52 816.01 158.71 812.85C145.44 801.8 138.79 788.89 138.79 775.99V744.89C138.79 757.8 145.43 770.7 158.71 781.74C162.52 784.91 166.84 787.94 171.71 790.76C174.94 792.62 178.33 794.34 181.82 795.94C189.07 799.23 196.85 801.92 204.96 804.03C212.44 805.98 220.2 807.42 228.1 808.37C235.73 809.31 243.5 809.75 251.26 809.74C259.01 809.74 266.8 809.27 274.4 808.33C282.32 807.38 290.07 805.94 297.56 803.96C305.68 801.86 313.45 799.15 320.7 795.84C324.12 794.28 327.42 792.57 330.6 790.76C335.56 787.89 339.98 784.79 343.82 781.57C356.69 770.81 363.23 758.25 363.49 745.67V745.66Z",
    fill: "#D7DCE0",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 714.55V745.66C363.23 758.24 356.68 770.79 343.82 781.56C339.98 784.79 335.56 787.88 330.6 790.75C327.43 792.57 324.12 794.27 320.7 795.83C313.45 799.14 305.68 801.85 297.56 803.95C290.08 805.93 282.32 807.37 274.4 808.32C266.79 809.26 259.01 809.73 251.26 809.73C243.51 809.74 235.74 809.3 228.1 808.36C220.2 807.41 212.44 805.97 204.96 804.02C196.85 801.91 189.07 799.22 181.82 795.93C178.32 794.33 174.93 792.61 171.71 790.75C166.84 787.93 162.52 784.91 158.71 781.73C145.44 770.69 138.79 757.79 138.79 744.88V713.77C138.79 726.68 145.43 739.58 158.71 750.62C162.52 753.79 166.84 756.82 171.71 759.64C174.94 761.5 178.33 763.22 181.82 764.82C189.07 768.11 196.85 770.8 204.96 772.91C212.44 774.85 220.2 776.3 228.1 777.25C235.73 778.19 243.5 778.63 251.26 778.63C259.02 778.63 266.8 778.14 274.4 777.23C282.32 776.25 290.07 774.8 297.56 772.82C305.68 770.73 313.45 768.02 320.7 764.71C324.12 763.15 327.42 761.44 330.6 759.63C335.56 756.76 339.98 753.66 343.82 750.44C356.69 739.68 363.23 727.12 363.49 714.54V714.55Z",
    fill: "#C2C7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 682.84V714.55C363.23 727.13 356.68 739.68 343.82 750.45C339.98 753.68 335.56 756.77 330.6 759.64C327.43 761.46 324.12 763.16 320.7 764.72C313.45 768.03 305.68 770.74 297.56 772.83C290.08 774.81 282.32 776.26 274.4 777.24C266.79 778.15 259.01 778.64 251.26 778.64C243.51 778.64 235.74 778.19 228.1 777.26C220.2 776.31 212.44 774.86 204.96 772.92C196.85 770.81 189.07 768.12 181.82 764.83C178.32 763.23 174.93 761.51 171.71 759.65C166.84 756.83 162.52 753.81 158.71 750.63C145.44 739.59 138.79 726.69 138.79 713.78V682.07C138.79 694.98 145.43 707.88 158.71 718.92C162.52 722.09 166.84 725.12 171.71 727.94C174.94 729.8 178.33 731.52 181.82 733.12C189.07 736.41 196.85 739.1 204.96 741.21C212.44 743.18 220.2 744.6 228.1 745.55C235.73 746.49 243.5 746.93 251.26 746.93C259.02 746.93 266.8 746.46 274.4 745.53C282.32 744.55 290.07 743.12 297.56 741.14C305.68 739.04 313.45 736.33 320.7 733.02C324.12 731.46 327.42 729.75 330.6 727.94C335.56 725.07 339.98 721.97 343.82 718.75C356.69 707.99 363.23 695.43 363.49 682.85V682.84Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 682.03C363.49 682.03 363.49 682.3 363.49 682.84C363.36 695.42 356.68 707.97 343.82 718.74C339.98 721.97 335.56 725.06 330.6 727.93C327.43 729.75 324.12 731.45 320.7 733.01C313.45 736.32 305.68 739.03 297.56 741.13C290.08 743.11 282.32 744.55 274.4 745.52C266.79 746.44 259.01 746.92 251.26 746.92C243.51 746.92 235.74 746.47 228.1 745.54C220.2 744.59 212.44 743.17 204.96 741.2C196.85 739.09 189.07 736.4 181.82 733.11C178.32 731.51 174.93 729.79 171.71 727.93C166.84 725.11 162.52 722.09 158.71 718.91C145.44 707.87 138.79 694.97 138.79 682.06C138.79 665.45 149.76 648.85 171.69 636.18C215.57 610.84 286.69 610.84 330.59 636.18C352.5 648.84 363.48 665.44 363.48 682.02L363.49 682.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 682.84C363.23 695.42 356.68 707.97 343.82 718.74C339.98 721.97 335.56 725.06 330.6 727.93C327.43 729.75 324.12 731.45 320.7 733.01C313.45 736.32 305.68 739.03 297.56 741.13C290.08 743.11 282.32 744.55 274.4 745.52C266.79 746.44 259.01 746.92 251.26 746.92C243.51 746.92 235.74 746.47 228.1 745.54C220.2 744.59 212.44 743.17 204.96 741.2C196.85 739.09 189.07 736.4 181.82 733.11C178.32 731.51 174.93 729.79 171.71 727.93C166.84 725.11 162.52 722.09 158.71 718.91C145.44 707.87 138.79 694.97 138.79 682.06C138.79 665.45 149.76 648.85 171.69 636.18C215.57 610.84 286.69 610.84 330.59 636.18C352.5 648.84 363.48 665.44 363.48 682.02",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 714.55C363.23 727.13 356.68 739.68 343.82 750.45C339.98 753.68 335.56 756.77 330.6 759.64C327.43 761.46 324.12 763.16 320.7 764.72C313.45 768.03 305.68 770.74 297.56 772.83C290.08 774.81 282.32 776.26 274.4 777.24C266.79 778.15 259.01 778.64 251.26 778.64C243.51 778.64 235.74 778.19 228.1 777.26C220.2 776.31 212.44 774.86 204.96 772.92C196.85 770.81 189.07 768.12 181.82 764.83C178.32 763.23 174.93 761.51 171.71 759.65C166.84 756.83 162.52 753.81 158.71 750.63C145.44 739.59 138.79 726.69 138.79 713.78",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 745.66C363.23 758.24 356.68 770.79 343.82 781.56C339.98 784.79 335.56 787.88 330.6 790.75C327.43 792.57 324.12 794.27 320.7 795.83C313.45 799.14 305.68 801.85 297.56 803.95C290.08 805.93 282.32 807.37 274.4 808.32C266.79 809.26 259.01 809.73 251.26 809.73C243.51 809.74 235.74 809.3 228.1 808.36C220.2 807.41 212.44 805.97 204.96 804.02C196.85 801.91 189.07 799.22 181.82 795.93C178.32 794.33 174.93 792.61 171.71 790.75C166.84 787.93 162.52 784.91 158.71 781.73C145.44 770.69 138.79 757.79 138.79 744.88",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 776.76C363.23 789.35 356.68 801.91 343.82 812.67C339.98 815.9 335.56 818.97 330.6 821.85C327.43 823.68 324.12 825.37 320.7 826.93C313.45 830.24 305.68 832.95 297.56 835.05C290.08 837.03 282.32 838.48 274.4 839.43C266.79 840.35 259.01 840.83 251.26 840.83C243.51 840.86 235.74 840.38 228.1 839.47C220.2 838.51 212.44 837.07 204.96 835.13C196.85 833.02 189.07 830.32 181.82 827.04C178.32 825.43 174.93 823.7 171.71 821.85C166.84 819.04 162.52 816.01 158.71 812.85C145.44 801.8 138.79 788.89 138.79 775.99",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 807.88C363.23 820.46 356.68 833.01 343.82 843.78C339.98 847.01 335.56 850.1 330.6 852.94C327.43 854.78 324.12 856.46 320.7 858.05C313.45 861.36 305.68 864.07 297.56 866.16C290.08 868.14 282.32 869.59 274.4 870.54C266.79 871.48 259.01 871.95 251.26 871.95C243.51 871.96 235.74 871.49 228.1 870.58C220.2 869.63 212.44 868.18 204.96 866.23C196.85 864.13 189.07 861.43 181.82 858.15C178.32 856.55 174.93 854.83 171.71 852.94C166.84 850.13 162.52 847.12 158.71 843.95C145.44 832.91 138.79 820.01 138.79 807.1",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 838.98C363.23 851.57 356.68 864.11 343.82 874.89C339.98 878.12 335.56 881.19 330.6 884.05C327.43 885.88 324.12 887.56 320.7 889.15C313.45 892.46 305.68 895.17 297.56 897.27C290.08 899.25 282.32 900.69 274.4 901.64C266.79 902.58 259.01 903.05 251.26 903.05C243.51 903.08 235.74 902.6 228.1 901.68C220.2 900.73 212.44 899.29 204.96 897.33C196.85 895.23 189.07 892.54 181.82 889.25C178.32 887.65 174.93 885.93 171.71 884.06C166.84 881.24 162.52 878.23 158.71 875.07C145.44 864.02 138.79 851.11 138.79 838.21",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 870.07C363.23 882.66 356.68 895.22 343.82 905.98C339.98 909.21 335.56 912.3 330.6 915.14C327.43 916.98 324.12 918.66 320.7 920.25C313.45 923.54 305.68 926.26 297.56 928.36C290.08 930.34 282.32 931.79 274.4 932.74C266.79 933.66 259.01 934.15 251.26 934.15C243.51 934.16 235.74 933.69 228.1 932.78C220.2 931.83 212.44 930.38 204.96 928.43C196.85 926.33 189.07 923.63 181.82 920.35C178.32 918.75 174.93 917.03 171.71 915.14C166.84 912.33 162.52 909.32 158.71 906.15C145.44 895.1 138.79 882.19 138.79 869.3",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.49 901.19C363.23 913.77 356.68 926.32 343.82 937.09C339.98 940.32 335.56 943.41 330.6 946.25C327.43 948.09 324.12 949.77 320.7 951.36C313.45 954.67 305.68 957.38 297.56 959.48C290.08 961.46 282.32 962.9 274.4 963.85C266.79 964.79 259.01 965.26 251.26 965.26C243.51 965.27 235.74 964.8 228.1 963.89C220.2 962.94 212.44 961.5 204.96 959.54C196.85 957.44 189.07 954.75 181.82 951.46C178.32 949.86 174.93 948.14 171.71 946.25C166.84 943.44 162.52 940.43 158.71 937.26C145.44 926.22 138.79 913.32 138.79 900.41",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.79 682.07V934.13C138.79 947.04 145.43 959.94 158.71 970.99C162.52 974.16 166.84 977.16 171.71 979.98C174.94 981.85 178.33 983.59 181.82 985.16C189.07 988.47 196.85 991.17 204.96 993.25C212.44 995.22 220.2 996.67 228.1 997.62C235.73 998.53 243.5 999 251.26 998.98C259.01 998.98 266.8 998.51 274.4 997.58C282.32 996.63 290.07 995.18 297.56 993.2C305.68 991.1 313.45 988.39 320.7 985.08C324.12 983.51 327.42 981.83 330.6 979.98C335.56 977.13 339.98 974.04 343.82 970.82C356.69 960.03 363.43 947.5 363.49 934.91C363.49 934.84 363.49 682.03 363.49 682.03",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.739 562.83C260.099 415.09 398.349 484.21 406.989 455.69C406.989 455.69 429.449 555.06 368.979 554.19C308.489 553.32 311.949 516.18 249.749 562.83H249.739Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51 613.1C250.72 612.91 251.88 612.8 253.01 612.75C283.45 614.15 348.49 664.37 295.05 695.23C283.42 701.95 268.26 705.4 253.01 705.59C237.77 705.4 222.62 701.96 210.98 695.23C159.5 665.51 217.98 617.94 249.51 613.1Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.43 573.3C199.3 556.35 172.59 587.81 133.1 587.81C62.8297 587.81 87.5597 535.87 34.6797 491.79C84.3097 525.09 215.3 412.09 248.43 573.31V573.3Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.01 705.59C237.77 705.4 222.62 701.96 210.98 695.23C159.5 665.51 217.98 617.94 249.51 613.1C250.72 612.91 251.88 612.8 253.01 612.75C283.45 614.15 348.49 664.37 295.05 695.23C283.42 701.95 268.26 705.4 253.01 705.59Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.739 562.83C260.099 415.09 398.349 484.21 406.989 455.69C406.989 455.69 429.449 555.06 368.979 554.19C308.489 553.32 311.949 516.18 249.749 562.83H249.739Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.1 587.81C172.59 587.81 199.3 556.36 248.43 573.3C215.3 412.08 84.3097 525.08 34.6797 491.78C87.5697 535.87 62.8397 587.8 133.1 587.8V587.81Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1494 517.38C146.819 527.1 170.049 488.6 248.429 573.3",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3 491.62C342.38 511.18 287.93 480.86 249.74 562.83C246.84 579.53 247.87 598.66 249.51 613.1",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.51 613.1C251 626.29 253.01 635.58 253.01 635.58",
    stroke: "#969A9E",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.03 737.51C554.41 747.27 521.98 788.97 521.14 790.01V790.04L521.11 790.07L521.05 790.16C521.05 790.16 521.02 790.22 521.02 790.28L604.02 838.24L436.14 913.51L491.51 810.38L440.63 780.99L485.23 693.18L562.03 737.52V737.51Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.139 790.04V790.01C521.979 788.97 554.42 747.26 562.03 737.51L485.229 693.17L440.629 780.98L491.509 810.37L436.139 913.5L604.02 838.23L521.02 790.27C521.02 790.21 521.019 790.18 521.049 790.15L521.109 790.06L521.139 790.03V790.04ZM705.179 680.02V1176.92L328.729 959.55V462.71L705.179 680.03V680.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.74 465.54V962.44L705.18 1176.92V680.02L1076.74 465.54ZM1008.54 890.33V843.18L967.68 866.72V913.87L1008.54 890.33ZM1008.54 767.25V720.1L967.68 743.64V790.79L1008.54 767.25ZM1008.54 644.14V596.94L967.68 620.54V667.69L1008.54 644.15V644.14ZM915.49 944.02V896.87L874.69 920.41V967.61L915.49 944.01V944.02ZM915.49 820.94V773.79L874.69 797.33V844.48L915.49 820.94ZM915.49 697.78V650.63L874.69 674.23V721.38L915.49 697.78ZM822.5 997.71V950.56L781.7 974.16V1021.31L822.5 997.71ZM822.5 874.63V827.48L781.7 851.05V898.2L822.5 874.63ZM822.5 751.52V704.37L781.7 727.97V775.06L822.5 751.52Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.74 465.54L705.179 680.02L328.729 462.7L700.229 248.19L1076.74 465.54ZM871.5 452.86V399.95L716.219 310.29L518.369 424.54V477.48L673.619 567.11L871.5 452.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.54 843.18V890.33L967.67 913.87V866.73L1008.54 843.18Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.54 720.1V767.25L967.67 790.79V743.65L1008.54 720.1Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.54 596.94V644.14L967.67 667.69V620.54L1008.54 596.94Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.49 896.88V944.02L874.68 967.62V920.42L915.49 896.88Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.49 773.8V820.94L874.68 844.49V797.34L915.49 773.8Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.49 650.63V697.78L874.68 721.38V674.23L915.49 650.63Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.499 399.95V452.86L673.609 567.11V514.2L871.499 399.95Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.499 399.95L673.609 514.2L518.359 424.54L716.209 310.29L871.499 399.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.499 827.49V874.63L781.689 898.21V851.06L822.499 827.49Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.499 704.38V751.52L781.689 775.07V727.98L822.499 704.38Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.609 514.2V567.11L518.359 477.48V424.54L673.609 514.2Z",
    fill: "#459AA4",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.989 790.27H521.019",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.02 790.27C521.02 790.21 521.02 790.18 521.05 790.15L521.11 790.06L521.14 790.03V790C521.98 788.96 554.42 747.25 562.03 737.5L485.23 693.16L440.63 780.97L491.51 810.36L436.14 913.49L604.02 838.22L521.02 790.26V790.27Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.74 465.54L705.179 680.02L328.729 462.71L700.229 248.2L1076.74 465.54Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.18 680.02V1176.92",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.74 465.54V962.44L705.179 1176.92L328.729 959.54V462.71",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.499 399.95L673.609 514.2L518.359 424.54L716.209 310.29L871.499 399.95Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.609 514.2V567.11",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.499 399.95V452.86L673.609 567.11L518.359 477.48V424.54",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.499 751.52L781.689 775.07V727.98L822.499 704.38V751.52Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.49 697.78L874.68 721.38V674.23L915.49 650.63V697.78Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.54 644.14L967.67 667.69V620.54L1008.54 596.94V644.14Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.499 874.63L781.689 898.21V851.06L822.499 827.49V874.63Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.49 820.94L874.68 844.49V797.34L915.49 773.8V820.94Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.54 767.25L967.67 790.79V743.65L1008.54 720.1V767.25Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.49 944.02L874.68 967.62V920.42L915.49 896.88V944.02Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.54 890.33L967.67 913.87V866.73L1008.54 843.18V890.33Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergydark);
export default __webpack_public_path__ + "static/media/Energydark.73fb6784c4300cb4662835d21b779b3a.svg";
export { ForwardRef as ReactComponent };